import { combineReducers } from 'redux'
import { AutoSyncTypes } from '../../action_types'
import { removeItem, insertItem, updateObjectInArray } from 'src/utils/helpers'

function enabled(state = false, action) {
  switch (action.type) {
    case AutoSyncTypes.GET_AUTO_SYNC_CONFIG_SUCCESS:
    case AutoSyncTypes.TOGGLE_AUTO_SYNC_SUCCESS:
      return action.data.auto_sync_enabled
    default:
      return state
  }
}

function rules(state = [], action) {
  switch (action.type) {
    case AutoSyncTypes.GET_AUTO_SYNC_CONFIG_SUCCESS:
      return action.data.rules
    case AutoSyncTypes.CREATE_AUTO_SYNC_RULE_SUCCESS:
      return insertItem(state, action.data)
    case AutoSyncTypes.UPDATE_AUTO_SYNC_RULE_SUCCESS:
      return updateObjectInArray(state, action.data)
    case AutoSyncTypes.DELETE_AUTO_SYNC_RULE_SUCCESS:
      return removeItem(state, action.id)
    default:
      return state
  }
}

export default combineReducers({
  enabled,
  rules,
})
